export default __webpack_public_path__ + "static/media/ea_ln_2.4ffd1102.png";